// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_97-0";